import { useSearchParams } from "react-router-dom";
import queryString from "query-string";
import { Constants } from "../contants";

const PAGE = "page";
const PAGE_SIZE = "size";

function useParam() {
  const [urlSearchParams] = useSearchParams();

  const getQueryObject = () => {
    const query = urlSearchParams.toString();
    return queryString.parse(query);
  };

  const getQueryParams = (queryParams) => {
    const params = {
      page: queryParams?.page || 0,
      size: queryParams?.size || Constants.DEFAULT_PAGE_SIZE,
    };
    const updatedQueryParams = { ...queryParams };
    delete updatedQueryParams[PAGE];
    delete updatedQueryParams[PAGE_SIZE];
    return [updatedQueryParams, params];
  };
  return {
    getQueryObject,
    getQueryParams,
    urlSearchParams,
  };
}

export default useParam;
